import { useQuery } from '@tanstack/react-query';
import { fetchMatchList } from '../api/client';

export function useMatchList(competitionId, enabled = true) {
  return useQuery({
    queryKey: ['match-list', competitionId],
    queryFn: () => fetchMatchList(competitionId),
    enabled: Boolean(enabled && competitionId),
    staleTime: 60_000,
  });
}
